import {useEffect} from 'react'
import {Navigate, Routes} from 'react-router-dom'
import {useGlobalAuthentication} from '../Authentication'

export function Logout() {
  const {logout} = useGlobalAuthentication()
  useEffect(() => {
    logout()
    document.location.reload()
  }, [logout])

  return (
    <Routes>
      <Navigate to='/auth/login' />
    </Routes>
  )
}
